import script from "./Auditoria.vue?vue&type=script&setup=true&lang=js"
export * from "./Auditoria.vue?vue&type=script&setup=true&lang=js"

import "./Auditoria.vue?vue&type=style&index=0&id=796e54c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796e54c1"]])

export default __exports__